
export function HeroSection() {
  return (
    <section 
      className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/a3ff173c95df7bd02274fc762fa1b2f5.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="flex items-center justify-center">
          <div className="text-white text-center max-w-4xl">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Your Trusted Realtor®,
              <span className="block text-yellow-400">Making Moves That Matter</span>
            </h1>
            <p className="text-xl lg:text-2xl mb-8 leading-relaxed">
              Guiding Michigan families to homeownership with integrity, expertise, and heart. 
              From first-time buyers to luxury waterfront homes — your dreams are my mission.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-yellow-500 text-black px-8 py-4 rounded-lg text-lg font-semibold hover:bg-yellow-400 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-calendar-check-line mr-2"></i>
                Book Free Consultation
              </button>
              <button className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-black transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-phone-line mr-2"></i>
                Call (248) 248-4801
              </button>
            </div>
            <div className="flex items-center justify-center mt-8 space-x-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-yellow-400">50+</div>
                <div className="text-sm">Happy Families</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-yellow-400">100%</div>
                <div className="text-sm">Satisfaction Rate</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-yellow-400">5.0★</div>
                <div className="text-sm">Client Rating</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
